// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SevenZipIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path fill="#292928" d="M1 6h22v14H1z" />
    <path fill="#F7F7F8" d="M13 7h9v12h-9z" />
    <path fill="#292928" d="M1 4h12v15H1z" />
    <path
      fill="#F7F7F8"
      d="M4.67 18v-.4q0-.62.1-1.05t.4-.99L8.9 9.04V8.8H3V7h8v2.39l-3.94 6.96q-.2.36-.28.64a3 3 0 0 0-.08.7V18z"
    />
    <path
      fill="#292928"
      d="M15 16.35v-1.92l3.48-2.9v-.2h-3.35V10h5.12v1.92l-3.48 2.9v.2h3.58v1.33z"
    />
  </svg>,
  "SevenZip",
);
export default SevenZipIcon;
